<template>
  <div class="login-sms">
    <c-nav></c-nav>
    <div class="a-page-head">
      <div class="a-page-title">验证手机号</div>
    </div>

    <c-input
      label="手机号码"
      placeholder="请输入手机号"
      v-model="phone"
      :autofoucs="true">
    </c-input>

    <c-input label="验证码" placeholder="请输入验证码" v-model="code" noclear>
      <div v-if="seconds > 0" class="a-text-16 a-gray">{{ seconds }}秒后重试</div>
      <div v-else class="a-text-16 a-blue" @click="onSend">发送验证码</div>
    </c-input>

    <div class="auth" v-if="showAuth" >
      <div @click="checkedAuth" class="icon" :class="checked?'checked':''"/>
      <p @click="checkedAuth">我已阅读并同意</p>
      <p @click="jump(0)" class="f2">「服务协议」</p>
      <p>和</p>
      <p @click="jump(1)" class="f2">「隐私政策」</p>

    </div>

    <div class="a-btn-line a-fix-bottom">
      <div class="a-btn" @click="onSubmit">验 证</div>
    </div>
  </div>
</template>

<script>
import validate from "../../utils/validate";
import API from "../../api";
import auth from "../web";
import localStorage from "../../utils/localStorage";
import authRequest from "../../request/auth";

export default {
  data() {
    return {
      phone: "",
      code: "",
      seconds: 0,
      checked: false,
      showAuth: false,
    };
  },

  created() {
    const ptid = localStorage.get('ptid')
    this.showAuth = ptid === 'huaweiscreen';
  },

  beforeDestroy() {
    clearTimeout(this._timer);
  },

  methods: {
    checkedAuth() {
      this.checked = !this.checked;
    },

    jump(index) {
      const link = [
        'https://dl.rsscc.cn/faq/policyagreement/gtgjserviceagreement.html',
        'https://dl.rsscc.cn/faq/policyagreement/gtgjprivacypolicy.html'
      ];

      this.$router.push( {
        path : '/pages/webview',

        query : {
          src : encodeURIComponent( link[ index ] )
        }
      } );
    },

    alert(message) {
      this.$notify({
        message
      });
    },

    countdown() {
      const seconds = ~~((this._till - new Date().getTime()) / 1000);

      if (seconds > 0) {
        this.seconds = seconds;
        this._timer = setTimeout(() => {
          this.countdown();
        }, 1000);
      } else {
        this.seconds = 0;
      }
    },

    onSend() {
      if (this.seconds > 0) {
        return;
      }

      if (!validate.phone(this.phone)) {
        this.alert("请输入正确的手机号");
        return;
      }

      clearTimeout(this._timer);

      //this.$withLoading(API.login["4101"])({
      this.$withLoading(API.login.sendDomesticVerifyCode)({
        phone: this.phone
      })
        .then(auth.handleLoginRes("RequestCodeError"))
        .then(() => {
          this._till = new Date().getTime() + 60 * 1000;
          this.countdown();
        })
        .catch(e => {
          this.alert(e.message || "抱歉，我们遇到一点问题，请您稍后再试。");
        });
    },

    onSubmit() {
      if (!this.code) {
        this.alert("请输入验证码");
        return;
      }

      if (this.showAuth && !this.checked) {
        this.alert("请先阅读并同意「服务协议」和「隐私政策」");
        return;
      }

      this.$withLoading(API.login["41021"])({
        phone: this.phone,
        code: this.code
      })
        .then(auth.handleLoginRes("RequestCodeError"))
        .then(r => {
          authRequest.logout(); // 清除上一用户信息（authcode）
          localStorage.set("authcode", r.authcode);
          localStorage.set("refreshcode", r.refreshcode);
          localStorage.set("authExpiretime", r.authExpiretime);
          localStorage.set("refreshExpiretime", r.refreshExpiretime);
          localStorage.set("user", r.user);

          let ptid = localStorage.get("ptid") || "";
          if (
            ptid === "quickapp" &&
            system &&
            system.postMessage &&
            typeof system.postMessage === "function"
          ) {
            let message = {
              authcode: r.authcode,
              refreshcode: r.refreshcode
            };
            system.postMessage(JSON.stringify(message));
          }
        })
        .then(() => {
          this.done();
        })
        .catch(e => {
          this.alert(e.message || "网络服务异常，请稍候再试");
        });
    },

    done() {
      const { ru = "", rp = "", refresh = "", callback = null } =
        this.$route.params || {};

      // 鸿蒙系统登录成功调用
      const ptid = localStorage.get('ptid')
      if (ptid === 'huaweiscreen' || ptid === 'vivoscreen') {
        const obj = {
          method: 'login',
          params: this.phone || '',
        }
        window.widgetNativeApi && window.widgetNativeApi.call(JSON.stringify(obj));
      }

      if (ru) {
        console.log(`ru: ${ru},rp: ${rp},refresh: ${refresh}`);

        // 如果已经加载了页面，就用单页跳转，否则用location
        const matched = this.$router.getMatchedComponents(rp);

        console.log("matched:", matched);

        if (rp && matched && matched.length > 0 && !refresh) {
          this.handleCallBack(callback);
          this.$router.replace(rp);
        } else {
          this.handleCallBack(callback);
          location.replace(ru);
        }
      } else {
        this.handleCallBack(callback);
        this.$router.back();
      }
    },

    handleCallBack(fn) {
      if (fn && typeof fn === "function") {
        fn();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';
.auth {
  display: flex;
  flex-direction: row;
  font-size: 14*$px;
  line-height: 20*$px;
  padding-left: 18*$px;
  text-align: center;
  .icon {
    height: 16*$px;
    width: 16*$px;
    margin-right: 8*$px;
    background: url(./image/uncheck.jpg) no-repeat center;
    background-size: cover;
    &.checked {
      background: url(./image/checked.jpg) no-repeat center;
      background-size: cover;
    }
  }

  .f2 {
    color: #1188ff;
  }
}


</style>



// WEBPACK FOOTER //
// src/auth/login/sms.vue